export const MIME_TO_EXTENSION: { [key: string]: string } = {
  'image/png': '.png',
  'image/jpeg': '.jpg',
  'image/jpg': '.jpg',
  'image/gif': '.gif',
  'image/webp': '.webp',
  'image/tiff': '.tiff',
  'image/bmp': '.bmp',
  'image/ico': '.ico',
  'image/svg+xml': '.svg',
  'application/pdf': '.pdf',
};

export const AI_DERM_FILE_EXTENSION_TO_TYPE: Record<string, string> = {
  'jpg': 'jpeg',
  'jpeg': 'jpeg',
  'png': 'png',
  'bmp': 'bmp',
  'gif': 'gif',
  'tiff': 'tiff',
  'tif': 'tiff',
  'ppm': 'ppm',
  'pgm': 'pgm',
  'pbm': 'pbm',
  'webp': 'webp',
  'dcm': 'dicom',
  'dicom': 'dicom',
  'heic': 'heic',
  'heif': 'heif'
};

export type ImageError = {
  status: number;
  message: string;
};
